import { Injectable, signal } from '@angular/core';

export enum ViewModeEnum {
    LIST = 'list',
    MAP = 'map',
}

@Injectable({
    providedIn: 'root',
})
export class ViewModeService {
    public readonly activatedViewMode = signal(ViewModeEnum.MAP);
}
